export default "__VITE_ASSET__BPvG6mcu__"